import { Box } from '@chakra-ui/react';

export const RoundBadge = ({ color = 'danger.500', ...props }) => {
    return <Box p={1} borderRadius={'full'} bgColor={color} {...props} />;
};
